import DTOVueGUITheme = namaTypes.DTOVueGUITheme;
import DTOGUIColorTheme = namaTypes.DTOGUIColorTheme;

export const namaDefaultTheme: DTOVueGUITheme = {
  code: "namaDefaultTheme",
  id: "nama-default-theme",
  name1: "الثيم الإفتراضي",
  name2: "Default Theme",
  lightColorTheme: {
    primaryColor: "#0C82AA",
    primaryBackgroundColor: "#F8F9FA",
    fontColor: "#000000",
    iconsColor: "#48bfe6",
    warningColor: "#DC3545"
  },
  darkColorTheme: {
    primaryColor: "#18ADE3",
    primaryBackgroundColor: "#383838",
    fontColor: "#FFFFFF",
    iconsColor: "#2097be",
    warningColor: "#CF6679"
  },
  fontSize: "Medium",
  darkMode: "DefaultValue",
  defaultTheme: false,
  systemTheme: true
};

/** A built-in theme baked into the client; its colors flow through applyTheme like any server theme. */
function builtInTheme(code: string, name1: string, name2: string, lightColorTheme: DTOGUIColorTheme, darkColorTheme: DTOGUIColorTheme,
                      darkNavBarAndSideBar = false): DTOVueGUITheme {
  return {
    code, id: code, name1, name2,
    lightColorTheme, darkColorTheme,
    fontSize: "Medium",
    darkMode: "DefaultValue",
    defaultTheme: false,
    systemTheme: true,
    darkNavBarAndSideBar
  };
}

export const builtInThemes: DTOVueGUITheme[] = [
  namaDefaultTheme,
  builtInTheme("nm-rose", "وردي", "Pink",
    {
      primaryColor: "#A8426C",
      primaryBackgroundColor: "#FBF6F8",
      secondaryBackgroundColor: "#FFFFFF",
      thirdBackgroundColor: "#FAF1F5",
      fontColor: "#2E1F2A",
      fontLabelColor: "#6F5A67",
      fontHeaderColor: "#2E1F2A",
      fontMenuColor: "#3A2A40",
      iconsColor: "#8A2F55",
      warningColor: "#C0405A"
    },
    {
      primaryColor: "#A8426C",
      primaryBackgroundColor: "#140F12",
      secondaryBackgroundColor: "#1F171B",
      thirdBackgroundColor: "#271E22",
      fontColor: "#EDE9EB",
      fontLabelColor: "#B7A4AD",
      fontHeaderColor: "#F6F4F5",
      fontMenuColor: "#E3DCE5",
      iconsColor: "#DFAEC3",
      warningColor: "#CC667A"
    }),
  builtInTheme("nm-admiral", "كحلي", "Navy",
    {
      primaryColor: "#2A64BE",
      primaryBackgroundColor: "#EEF1F4",
      secondaryBackgroundColor: "#FFFFFF",
      thirdBackgroundColor: "#F4F6F8",
      fontColor: "#151A21",
      fontLabelColor: "#505B69",
      fontHeaderColor: "#0F1319",
      fontMenuColor: "#1d222a",
      iconsColor: "#1F4E9A",
      warningColor: "#B73A32"
    },
    {
      primaryColor: "#2A64BE",
      primaryBackgroundColor: "#14181E",
      secondaryBackgroundColor: "#1B2028",
      thirdBackgroundColor: "#20262F",
      fontColor: "#E7EAEE",
      fontLabelColor: "#9AA4B2",
      fontHeaderColor: "#F2F4F7",
      fontMenuColor: "#D5DAE1",
      iconsColor: "#9CC2FF",
      warningColor: "#E5675F"
    }, true),
  builtInTheme("nm-confetti", "فيروزي", "Teal",
    {
      primaryColor: "#0E7C72",
      primaryBackgroundColor: "#FFF9F0",
      secondaryBackgroundColor: "#FFFFFF",
      thirdBackgroundColor: "#FFF3E2",
      fontColor: "#2B2335",
      fontLabelColor: "#655C70",
      fontHeaderColor: "#2B2335",
      fontMenuColor: "#2B2335",
      iconsColor: "#0B5F57",
      warningColor: "#C93A48"
    },
    {
      primaryColor: "#0E7C72",
      primaryBackgroundColor: "#141210",
      secondaryBackgroundColor: "#1D1B18",
      thirdBackgroundColor: "#26231F",
      fontColor: "#EDEBE9",
      fontLabelColor: "#B6AFA5",
      fontHeaderColor: "#F6F5F4",
      fontMenuColor: "#E3E1DD",
      iconsColor: "#9AF4EB",
      warningColor: "#D35F6A"
    }),
  builtInTheme("nm-fuchsia", "فوشيا", "Fuchsia",
    {
      primaryColor: "#C0166A",
      primaryBackgroundColor: "#FCF7FA",
      secondaryBackgroundColor: "#FFFFFF",
      thirdBackgroundColor: "#FBF0F6",
      fontColor: "#29111F",
      fontLabelColor: "#6E5364",
      fontHeaderColor: "#29111F",
      fontMenuColor: "#29111F",
      iconsColor: "#9C0F55",
      warningColor: "#D12D3F"
    },
    {
      primaryColor: "#C0166A",
      primaryBackgroundColor: "#150F12",
      secondaryBackgroundColor: "#1F161B",
      thirdBackgroundColor: "#281D23",
      fontColor: "#EDE9EB",
      fontLabelColor: "#B7A4AF",
      fontHeaderColor: "#F6F4F5",
      fontMenuColor: "#E5DCE1",
      iconsColor: "#F39AC6",
      warningColor: "#DB5766"
    }),
  builtInTheme("nm-crimson", "أحمر", "Red",
    {
      primaryColor: "#B42318",
      primaryBackgroundColor: "#F8F6F5",
      secondaryBackgroundColor: "#FFFFFF",
      thirdBackgroundColor: "#F6F1EF",
      fontColor: "#221A18",
      fontLabelColor: "#675A56",
      fontHeaderColor: "#221A18",
      fontMenuColor: "#221A18",
      iconsColor: "#97201A",
      warningColor: "#B42318"
    },
    {
      primaryColor: "#B42318",
      primaryBackgroundColor: "#141110",
      secondaryBackgroundColor: "#1D1918",
      thirdBackgroundColor: "#26201F",
      fontColor: "#EDE9E9",
      fontLabelColor: "#B6A7A5",
      fontHeaderColor: "#F6F4F4",
      fontMenuColor: "#E3DEDD",
      iconsColor: "#F2A29C",
      warningColor: "#E05C52"
    }),
  builtInTheme("nm-ocean", "أزرق فاتح", "Light Blue",
    {
      primaryColor: "#0A63BF",
      primaryBackgroundColor: "#F3F8FC",
      secondaryBackgroundColor: "#FFFFFF",
      thirdBackgroundColor: "#F0F6FB",
      fontColor: "#0F2233",
      fontLabelColor: "#4F6475",
      fontHeaderColor: "#0F2233",
      fontMenuColor: "#0F2233",
      iconsColor: "#0A55A3",
      warningColor: "#CC3B3B"
    },
    {
      primaryColor: "#0A63BF",
      primaryBackgroundColor: "#0C1217",
      secondaryBackgroundColor: "#131B23",
      thirdBackgroundColor: "#18232D",
      fontColor: "#E9EBED",
      fontLabelColor: "#A4AEB7",
      fontHeaderColor: "#F4F5F6",
      fontMenuColor: "#DCE1E5",
      iconsColor: "#9AC6F4",
      warningColor: "#D55D5D"
    }),
  builtInTheme("nm-forest", "أخضر", "Green",
    {
      primaryColor: "#1D7348",
      primaryBackgroundColor: "#F3F6F2",
      secondaryBackgroundColor: "#FFFFFF",
      thirdBackgroundColor: "#EEF3EC",
      fontColor: "#1A2A20",
      fontLabelColor: "#536458",
      fontHeaderColor: "#163A2B",
      fontMenuColor: "#1f2f25",
      iconsColor: "#17603C",
      warningColor: "#B9382F"
    },
    {
      primaryColor: "#1D7348",
      primaryBackgroundColor: "#0F1411",
      secondaryBackgroundColor: "#171F1A",
      thirdBackgroundColor: "#1E2722",
      fontColor: "#E9EDEA",
      fontLabelColor: "#A4B7AC",
      fontHeaderColor: "#F4F6F5",
      fontMenuColor: "#DCE5E0",
      iconsColor: "#A5E8C7",
      warningColor: "#D6645C"
    }),
  builtInTheme("nm-midnight", "ذهبي", "Gold",
    {
      primaryColor: "#121A33",
      primaryBackgroundColor: "#F6F4EF",
      secondaryBackgroundColor: "#FFFFFF",
      thirdBackgroundColor: "#F3F0E8",
      fontColor: "#121626",
      fontLabelColor: "#535A6E",
      fontHeaderColor: "#0E1322",
      fontMenuColor: "#535A6E",
      iconsColor: "#6E5114",
      warningColor: "#B3392F"
    },
    {
      primaryColor: "#946F1C",
      primaryBackgroundColor: "#080B14",
      secondaryBackgroundColor: "#0E1322",
      thirdBackgroundColor: "#121A2D",
      fontColor: "#E8EBF4",
      fontLabelColor: "#97A1BA",
      fontHeaderColor: "#F3F0E8",
      fontMenuColor: "#D9DEEA",
      iconsColor: "#E6C27A",
      warningColor: "#F07A7A"
    }, true),
  builtInTheme("nm-sunset", "برتقالي", "Orange",
    {
      primaryColor: "#B24E0A",
      primaryBackgroundColor: "#FBF5EE",
      secondaryBackgroundColor: "#FFFDFA",
      thirdBackgroundColor: "#F8EEE2",
      fontColor: "#2B1D14",
      fontLabelColor: "#6B5543",
      fontHeaderColor: "#2B1D14",
      fontMenuColor: "#34251c",
      iconsColor: "#8E3F08",
      warningColor: "#B7352B"
    },
    {
      primaryColor: "#B24E0A",
      primaryBackgroundColor: "#15120F",
      secondaryBackgroundColor: "#201A16",
      thirdBackgroundColor: "#29221C",
      fontColor: "#EDEAE9",
      fontLabelColor: "#B7ADA4",
      fontHeaderColor: "#F6F5F4",
      fontMenuColor: "#E5E0DC",
      iconsColor: "#F4BE9A",
      warningColor: "#D8635A"
    }),
  builtInTheme("nm-corporate", "أزرق", "Blue",
    {
      primaryColor: "#1E4F91",
      primaryBackgroundColor: "#F2F4F7",
      secondaryBackgroundColor: "#FFFFFF",
      thirdBackgroundColor: "#F7F8FA",
      fontColor: "#1B2430",
      fontLabelColor: "#525E6D",
      fontHeaderColor: "#1B2430",
      fontMenuColor: "#1B2430",
      iconsColor: "#1B4680",
      warningColor: "#B83A3A"
    },
    {
      primaryColor: "#1E4F91",
      primaryBackgroundColor: "#101114",
      secondaryBackgroundColor: "#181A1E",
      thirdBackgroundColor: "#1E2227",
      fontColor: "#E9EAED",
      fontLabelColor: "#A4ACB7",
      fontHeaderColor: "#F4F5F6",
      fontMenuColor: "#DDE0E4",
      iconsColor: "#A2C1EC",
      warningColor: "#CE6464"
    }),
  builtInTheme("nm-violet", "بنفسجي", "Purple",
    {
      primaryColor: "#5B3FD9",
      primaryBackgroundColor: "#F6F5FB",
      secondaryBackgroundColor: "#FFFFFF",
      thirdBackgroundColor: "#F3F1FA",
      fontColor: "#1C1833",
      fontLabelColor: "#5A5575",
      fontHeaderColor: "#1C1833",
      fontMenuColor: "#1d1a2f",
      iconsColor: "#4A2FC0",
      warningColor: "#CF3654"
    },
    {
      primaryColor: "#5B3FD9",
      primaryBackgroundColor: "#0F0E15",
      secondaryBackgroundColor: "#171520",
      thirdBackgroundColor: "#1E1C29",
      fontColor: "#E9E9ED",
      fontLabelColor: "#A7A4B7",
      fontHeaderColor: "#F4F4F6",
      fontMenuColor: "#DEDCE5",
      iconsColor: "#AFA1EC",
      warningColor: "#D85A73"
    }),
  builtInTheme("nm-minimal", "أبيض وأسود", "Black & White",
    {
      primaryColor: "#393939",
      primaryBackgroundColor: "#FFFFFF",
      secondaryBackgroundColor: "#FFFFFF",
      thirdBackgroundColor: "#FAFAFA",
      fontColor: "#171717",
      fontLabelColor: "#5F5F5F",
      fontHeaderColor: "#171717",
      fontMenuColor: "#262626",
      iconsColor: "#0F5F58",
      warningColor: "#B42318"
    },
    {
      primaryColor: "#737373",
      primaryBackgroundColor: "#121212",
      secondaryBackgroundColor: "#1B1B1B",
      thirdBackgroundColor: "#222222",
      fontColor: "#EBEBEB",
      fontLabelColor: "#ADADAD",
      fontHeaderColor: "#F5F5F5",
      fontMenuColor: "#E0E0E0",
      iconsColor: "#AFDEDB",
      warningColor: "#E05C52"
    }, true),
];

/** Maps each SystemTheme enum value (global config "Default System Theme") to its built-in theme code. */
const themeCodeBySystemTheme: Record<string, string> = {
  Default: namaDefaultTheme.code!,
  Pink: "nm-rose",
  Navy: "nm-admiral",
  Teal: "nm-confetti",
  Fuchsia: "nm-fuchsia",
  Red: "nm-crimson",
  LightBlue: "nm-ocean",
  Green: "nm-forest",
  Gold: "nm-midnight",
  Orange: "nm-sunset",
  Blue: "nm-corporate",
  Purple: "nm-violet",
  BlackAndWhite: "nm-minimal"
};

/** window.defaultSystemTheme is written by translation.js?lang=Nama, so it is available before login. */
export function findGlobalConfigDefaultTheme(): DTOVueGUITheme | undefined {
  const code = themeCodeBySystemTheme[(window as any).defaultSystemTheme];
  return code ? builtInThemes.find(t => t.code === code) : undefined;
}
